import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { handleAxiosError } from "./responses/AxiosResponseHandler";

class GetSASTokenApi {

    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async getSasToken(isFriend: boolean, userId: string, profileCount: number) {

        try {

            const params = isFriend ? { isFriend } : {};
            const authenticationResponse = this.authClient.getAuthenticationResponse();
            const response = await axios.get(
                `${this.authClient.getApiRoot()}/GetSasToken/${userId}/${profileCount}`,
                {
                    params,
                    headers: {
                        Authorization: `Bearer ${authenticationResponse?.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: "",
                data: response.data 
            };

        } catch (error) {
            const errorResponse = handleAxiosError(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage,
            }
        }
    }
}

export default GetSASTokenApi;